import { NavigationClient, type NavigationOptions } from '@azure/msal-browser';
import type { NavigateFunction } from 'react-router';

/**
 * Overrides the default function MSAL navigation to use react-router
 * internal routing for redirects
 */
export class CustomNavigationClient extends NavigationClient {
  private navigate: NavigateFunction;

  constructor(navigate: NavigateFunction) {
    super();
    this.navigate = navigate;
  }

  /**
   * Navigates to other pages within the same web application
   * You can use the useNavigate hook provided by react-router to take advantage of client-side routing
   * @param url
   * @param options
   */
  async navigateInternal(url: string, options: NavigationOptions) {
    const relativePath = url.replace(window.location.origin, '');
    if (options.noHistory) {
      await this.navigate(relativePath, { replace: true });
    } else {
      await this.navigate(relativePath);
    }

    return false;
  }
}
